import { render, staticRenderFns } from "./MemberInput.vue?vue&type=template&id=c89d8b8e&"
import script from "./MemberInput.vue?vue&type=script&lang=js&"
export * from "./MemberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports